/**
 * User roles, keyed by the normalized form of the DB role name (roles.name):
 * lowercased, with spaces and hyphens turned into underscores.
 *
 *   "Super Admin"              -> super_admin
 *   "Third-Party Yard Spotter" -> third_party_yard_spotter
 *
 * Compare role names from the backend with normalizeRole(), never as raw strings.
 */
export enum Role {
  superAdmin = 'super_admin',
  admin = 'admin',
  manager = 'manager',
  dockCoordinator = 'dock_coordinator',
  carrier = 'carrier',
  transport = 'transport',
  spotter = 'spotter',
  thirdPartyYardSpotter = 'third_party_yard_spotter',
  user = 'user',
  viewer = 'viewer'
}

/**
 * Normalize a role name from the backend to its Role key
 */
export const normalizeRole = (role: string): string => {
  return role.toLowerCase().replace(/[\s-]+/g, '_');
};

/**
 * Whether a role name from the backend is the given role
 */
export const isRole = (roleName: string | null | undefined, role: Role): boolean => {
  return !!roleName && normalizeRole(roleName) === role;
};
